<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { AppMultiSelectSearchable } from '@shared/ui/selects'
import { RowSlot } from '@shared/ui/other'
import { AppTextarea } from '@shared/ui/fields'
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import DisciplineKanbanLink from './DisciplineKanbanLink.vue'
import { useDisciplineActivation } from '../model/discipline-activation.hook'

defineOptions({
  name: 'DisciplineActivation',
})

const {
  refForm,
  refExpectations,
  refKanbanUrl,
  refIsSaving,
  pace,
  scheduleLines,
  startDate,
  expectationOptions,
  setAgentSchedule,
  setPreferences,
  save,
} = useDisciplineActivation()
</script>

<template>
  <div class="discipline-activation">
    <div class="discipline-activation__header">
      <BtnPrimary
        color="emerald"
        text="Save"
        :disabled="refIsSaving"
        @click="save"
      />
    </div>
    <div class="discipline-activation__general">
      <CardAdmin
        title="Schedule info"
        fullwidth
      >
        <div class="discipline-activation__box">
          <RowSlot label="Pace per week:">
            <AppText name="body1">
              {{ pace }}
            </AppText>
          </RowSlot>
          <RowSlot label="Customers schedule:">
            <div class="discipline-activation__schedule">
              <AppText
                v-for="line in scheduleLines"
                :key="line"
                name="body1"
              >
                {{ line }}
              </AppText>
              <AppText name="body1">
                First lesson: {{ startDate }}
              </AppText>
            </div>
          </RowSlot>
          <RowSlot label="Final schedule (agent):">
            <AppTextarea
              :value="refForm.agentSchedule"
              @input="setAgentSchedule"
            />
          </RowSlot>
        </div>
      </CardAdmin>
      <CardAdmin
        title="Other info"
        fullwidth
      >
        <template #header>
          <DisciplineKanbanLink
            v-if="refKanbanUrl"
            :href="refKanbanUrl"
          />
        </template>
        <div class="discipline-activation__box">
          <RowSlot label="Expected results:">
            <AppMultiSelectSearchable
              v-model="refExpectations"
              placeholder="Select"
              :options="expectationOptions"
            />
          </RowSlot>
          <RowSlot label="Preferences:">
            <AppTextarea
              :value="refForm.preferences"
              placeholder="---"
              @input="setPreferences"
            />
          </RowSlot>
        </div>
      </CardAdmin>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineActivation.scss" />
